import {Component, inject, OnInit, OnDestroy} from '@angular/core';
import {TuningNamesTablesService} from "../../service/Tuning-names-tables.service";
import {TuningNameModel} from "../../models/Tuning-Name-model";
import {fadeInAnimation} from "../../animations/fadeInAnimation";

@Component({
    selector: 'app-tuning-names-table',
    templateUrl: './tuning-names-table.component.html',
    styleUrls: ['./tuning-names-table.component.css'],
    animations: [fadeInAnimation],
    host: {'[@fadeInAnimation]': ''}
})
export class TuningNamesTableComponent implements OnInit, OnDestroy {

    public tuningNamesService = inject(TuningNamesTablesService);
    draft: TuningNameModel = {} as TuningNameModel;
    searchQuery = '';

    get filteredTuningNames(): TuningNameModel[] {
        const query = this.searchQuery.trim().toLowerCase();
        return query ? this.tuningNamesService.tuningNames().filter(row =>
            row.correctTuningNames?.toLowerCase().includes(query) ||
            row.acceptedTuningNames?.toLowerCase().includes(query) ||
            row.usedAt?.toLowerCase().includes(query) ||
            String(row.tuningOrder).includes(query)
        ) : this.tuningNamesService.tuningNames();
    }

    acceptedNames(names: string | null): string[] {
        return names?.split(',').map(name => name.trim()).filter(Boolean) ?? [];
    }

    ngOnInit() {
        this.getTuningNames();
    }

    ngOnDestroy() {
        this.tuningNamesService.resetComponentState();
    }

    getTuningNames() {
        this.tuningNamesService.getTuningNamesTable()
    }

    onAddItems() {
        this.onExitItems();
        this.tuningNamesService.openNewRow();
    }

    saveNewRow() {
        this.tuningNamesService.addTuningNames();
    }

    deleteRow() {
        this.tuningNamesService.editInputRow.set(false);
    }

    onEditItems(index: number) {
        this.tuningNamesService.editInputRow.set(false);
        this.draft = {...this.tuningNamesService.tuningNames()[index]};
        this.tuningNamesService.tuningIndex.set(index);
    }

    onSaveItems() {
        if (this.tuningNamesService.tuningIndex() !== null) {
            this.tuningNamesService.updateTuningName(this.draft);
        }
    }

    onDeleteItems(element: TuningNameModel) {
        this.tuningNamesService.deleteTuningNames(element)
    }

    onExitItems() {
        this.tuningNamesService.tuningIndex.set(null);
        this.draft = {} as TuningNameModel;
    }

    displayUsedAt(usedAt: string | null): string {
        return usedAt || '-';
    }
}
